import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { RecipientsFilterService } from './recipients-filter.service';
import { Subscription } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { QnSbnDataServiceService } from '../../../../services/qn-sbn-data-service.service';
import { OneWebComponentsAngularModule } from '@one/angular';
import { RecipientsTableService } from '../../table/recipients-table/recipients-table.service';


@Component({
  selector: 'dl-recipients-filter',
  standalone: true,
  imports:[OneWebComponentsAngularModule,ReactiveFormsModule],
  templateUrl: './recipients-filter.component.html',
  styleUrl: './recipients-filter.component.scss'
})
export class RecipientsFilterComponent implements OnInit, OnDestroy {

  public width = '102px';

  public sourceList: any[] = [];

  public sourcePlaceholder = 'Source';
  
  public lblFilter: any[];
   public lblFilter2: any[];

  public warningsList: any[] = [];

  public warningPlaceholder = 'Warnings';

  
  public arrObj=[];
  public selSources=[];
  public selWarnings=[];


  private _sourceFormControlSubscription:Subscription;
  private _warningFormControlSubscription:Subscription;
  private _QnSbnDataServiceSubscription:Subscription;
  private _srcFilterSubscription:Subscription;
  private _dataStatusSubscription:Subscription;
  private _mappingDataSubscription:Subscription;

  public constructor(private recipientsFilterService: RecipientsFilterService, private recipientsTableService: RecipientsTableService, private _QnSbnDataService:QnSbnDataServiceService, private changeDetect:ChangeDetectorRef) { }
  
   warnings = [
    {label: "Email", value: "email"},
    {label: "Account IDs", value: "accId"}
  ];

  ngOnDestroy(): void {
    this._QnSbnDataServiceSubscription?.unsubscribe();
    this._srcFilterSubscription?.unsubscribe();
    this._dataStatusSubscription?.unsubscribe();
    this._mappingDataSubscription?.unsubscribe();
  }

  public ngOnInit(): void {
    // Subscribe to source filter data
    this._srcFilterSubscription = this.recipientsTableService.srcFilterData$.subscribe(data => {
      if (!this.recipientsTableService.isEmpty(data)) {
        this.recipientsFilterService.srcFilteredDataList = data;
      }
    });

    // Subscribe to mapped data for sourceList and warningDataList
    this._mappingDataSubscription = this._QnSbnDataService.mappingData$.subscribe(data => {
      if (!this._QnSbnDataService.isEmpty(data)) {
        this.recipientsFilterService.warningDataList = data['recipientData']?.['recipientTable'];
      }
    });

    this._QnSbnDataServiceSubscription = this._QnSbnDataService.mappingData$.subscribe(storeData => {
      if (!this._QnSbnDataService.isEmpty(storeData['recipientData'])) {
        this.sourceList = storeData['recipientData']['sourceName'] || [];
      }
      this.changeDetect.detectChanges();
    });

    // Initialize warnings based on existing filter data
    this.updateWarningsList();

    this._dataStatusSubscription = this.recipientsTableService.dataStatus$.subscribe(data => {
      if (!this.recipientsTableService.isEmpty(data)) {
        this.warningsList = this.warnings;
      } else {
        this.warningsList = [];
      }
      this.changeDetect.detectChanges();
    });

    this.recipientsTableService.data$.subscribe((data: any[]) => {
      if (!this.recipientsTableService.isEmpty(data)) {
        let res1 = data.filter(i => {
          if (this.isDuplicatedEmail(data, i)) {
            return i;
          }
        });
        let res2 = data.filter(i => {
          if (i.customerId === undefined || '' || null) {
            return i;
          }
        });
        let res4 = data.filter(i => {
          if (this.isDuplicatedName(data, i)) {
            return i;
          }
        });
        if (res1.length == 0 && res2.length == 0 && res4.length == 0) {
          this.warningsList = [];
        } else {
          this.warningsList = this.warnings;
        }
        this.changeDetect.detectChanges();
      } else {
        this.warningsList = [];
        this.changeDetect.detectChanges();
      }
    });
  }

  private updateWarningsList(): void {
    const srcEmpty = typeof this.recipientsFilterService.srcFilteredDataList === 'undefined'
      || (typeof this.recipientsFilterService.srcFilteredDataList === 'object'
        && this.recipientsFilterService.srcFilteredDataList.length == 0);
    const warnEmpty = typeof this.recipientsFilterService.warningDataList === 'undefined'
      || (typeof this.recipientsFilterService.warningDataList === 'object'
        && this.recipientsFilterService.warningDataList.length == 0);

    this.warningsList = (srcEmpty && warnEmpty) ? [] : this.warnings;
  }

   public isDuplicatedEmail(d: any, target: any): boolean{
    if(!d || !target) return false;
    const targetIndex = d.indexOf(target);
    return d.some((obj, index) => 
      index !== targetIndex && 
      obj.customerId === target.customerId &&
      obj.customerEmail === target.customerEmail);
    }

    public isDuplicatedName(d: any, target: any): boolean{
    if(!d || !target) return false;
    const targetIndex = d.indexOf(target);
    return d.some((obj, index) => 
      index !== targetIndex && 
      obj.customerId === target.customerId && 
      obj.customerName !== target.customerName);
    }

  ngAfterViewInit(): void {
    // Subscriptions are already set up in ngOnInit — just trigger initial warnings check
    this.updateWarningsList();
    this.changeDetect.detectChanges();
  }

  public sourceListValue(event: any) {
    // Handle different event structures
    this.selSources = event?.detail || event?.value || event || [];

      let val1=this.selWarnings;
      if (val1.length>0) {
        this.lblFilter = val1.map(item => item.label.trim().toLowerCase());
        if (this.selSources.length>0) {
          this.lblFilter2 = this.selSources.map(item => item.label.trim().toLowerCase());
          this.arrObj=[this.lblFilter2,this.lblFilter]
          this.recipientsFilterService.getfilteredData(this.arrObj);
          this.recipientsFilterService.getFilteredData(this.lblFilter,this.recipientsFilterService.srcFilteredDataList);
        }
        else {
          this.lblFilter2 = [];
          this.arrObj=[this.lblFilter2,this.lblFilter]
          this.recipientsFilterService.getfilteredData(this.arrObj);
          this.recipientsFilterService.getFilteredData(this.lblFilter,this.recipientsFilterService.warningDataList);
        }
      }
      else{
          this.lblFilter = [];
          if (this.selSources.length>0) {
            this.lblFilter2 = this.selSources.map(item => item.label.trim().toLowerCase());
            this.arrObj=[this.lblFilter2,this.lblFilter]
            this.recipientsFilterService.getfilteredData(this.arrObj);
          }
          else {
            this.lblFilter2 = [];
            this.arrObj=[this.lblFilter2,this.lblFilter]
            this.recipientsFilterService.getfilteredData(this.arrObj);
          }
      }
  }

  public warningListValue(event: any) {
    // Handle different event structures
    this.selWarnings = event?.detail || event?.value || event || [];
    
    let val1=this.selSources;
      if(val1.length>0){
        if (this.selWarnings) {
          this.lblFilter2 = this.selWarnings.map(item => item.label.trim().toLowerCase());
          this.recipientsFilterService.getFilteredData(this.lblFilter2,this.recipientsFilterService.srcFilteredDataList);
        } 
        else {
          this.lblFilter2 = [];
          this.recipientsFilterService.getFilteredData(this.lblFilter2,this.recipientsFilterService.srcFilteredDataList);
        }
      }
      else{
        if (this.selWarnings.length>0) {
          this.lblFilter2 = this.selWarnings.map(item => item.label.trim().toLowerCase());
          this.recipientsFilterService.getFilteredData(this.lblFilter2,this.recipientsFilterService.warningDataList);
        } 
        else {
          this.lblFilter2 = [];
          this.recipientsFilterService.getFilteredData(this.lblFilter2,this.recipientsFilterService.warningDataList);
        }
      }
  }
    
}

